import {Box, Button, IconButton, Modal} from "@mui/material";
import CloseIcon from "assets/icons/CloseIcon";
import GuideIcon from "assets/icons/GuideIcon";
import GuidePlayerIcon from "assets/icons/GuidePlayerIcon";
import React, {Fragment} from "react";

type Props = {
    item: any;
    onClose?: () => void;
};

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    p: 2,
    borderRadius: "8px",
};

function Guide({item, onClose}: Props) {
    const {
        title = "",
        description = [],
        video_thumbnail = "",
        video_title = "",
        video_url = "",
        tutorial = "",
    } = item;

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <div
                style={{
                    top: 0,
                    flex: 1,
                    minHeight: "240px",
                    backgroundColor: "#F8FAFC",
                    paddingTop: "40px",
                    paddingBottom: "40px",
                }}
            >
                <div
                    style={{position: "relative"}}
                    className="MuiContainer-root MuiContainer-maxWidthXl css-19r6kue-MuiContainer-root"
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <GuideIcon/>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginRight: "32px",
                                justifyContent: "space-between",
                                flex: 1,
                            }}
                        >
                            <div>
                <span
                    style={{
                        fontSize: "22px",
                        color: "#424242",
                        fontWeight: "bold",
                    }}
                >
                  {title}
                </span>
                            </div>
                            <div
                                style={{
                                    marginTop: "12px",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                {description.map(
                                    (
                                        item:
                                            | string
                                            | number
                                            | boolean
                                            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                                            | React.ReactFragment
                                            | React.ReactPortal
                                            | null
                                            | undefined,
                                        index: React.Key | null | undefined
                                    ) => (
                                        <span
                                            key={index}
                                            style={{
                                                fontSize: "16px",
                                                color: "#8D8E8F",
                                                marginTop: "8px",
                                            }}
                                        >
                      {item}
                    </span>
                                    )
                                )}
                            </div>
                            {tutorial && (
                                <div
                                    style={{
                                        marginTop: "12px",
                                    }}
                                >
                  <span
                      style={{
                          fontSize: "14px",
                          color: "#1062D0",
                      }}
                  >
                    مشاهده راهنما متنی
                  </span>
                                </div>
                            )}
                        </div>
                        {video_url && (
                            <div style={{flex: 1, paddingRight: "40px"}}>
                                <Button onClick={handleOpen}>
                                    <GuidePlayerIcon title={video_title} link={video_thumbnail}/>
                                </Button>
                            </div>
                        )}
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 16,
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                        }}
                    >
                        <span>بستن راهنما</span>
                        <IconButton
                            onClick={onClose}
                            size="small"
                            sx={{
                                width: "22px",
                                height: "22px",
                                border: "1px solid #95A3B5",
                                marginRight: "8px",
                            }}
                        >
                            <CloseIcon scale={0.4}/>
                        </IconButton>
                    </div>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{...style}}>
                    <video autoPlay={true} src={video_url} width={800} controls={true}></video>
                </Box>
            </Modal>
        </Fragment>
    );
}

export default Guide;
